import React from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Approach from "@/components/Approach";
import WhyChooseUs from "@/components/WhyChooseUs";
import Solutions from "@/components/Solutions";
import TargetMarket from "@/components/TargetMarket";
import Pricing from "@/components/Pricing";
import Team from "@/components/Team";
import Footer from "@/components/Footer";
import SiteBackground from "@/components/SiteBackground";
import BioDivider from "@/components/BioDivider";
import BioCursor from "@/components/BioCursor";

export default function Landing() {
    return (
        <main
            data-testid="landing-page"
            className="relative min-h-screen text-foreground"
        >
            <SiteBackground />
            <BioCursor />
            <Navbar />
            <Hero />
            <BioDivider variant="vine" />
            <About />
            <Approach />
            <BioDivider variant="helix" />
            <WhyChooseUs />
            <Solutions />
            <BioDivider variant="vine" />
            <TargetMarket />
            <BioDivider variant="vine" />
            <Pricing />
            <BioDivider variant="helix" />
            <Team />
            <Footer />
        </main>
    );
}
